import { useState, useEffect } from 'react'
import { getPlatformConfig } from '../lib/supabase'

// Marca de la plataforma (MYKLUBB) para pantallas pre-login: loading, reset de
// contrasena, activacion. Misma fuente y defaults que Login.js, extraidos a un
// hook para no duplicar. Inicializa desde cache para evitar el flash de marca.
const PLATFORM_CACHE_KEY = 'myklubb_platform_config'

export const usePlatformBranding = () => {
  const [platform, setPlatform] = useState(() => {
    try {
      const cached = localStorage.getItem(PLATFORM_CACHE_KEY)
      return cached ? JSON.parse(cached) : null
    } catch {
      return null
    }
  })

  useEffect(() => {
    getPlatformConfig().then(({ data }) => {
      if (data) {
        setPlatform(data)
        try {
          localStorage.setItem(PLATFORM_CACHE_KEY, JSON.stringify(data))
        } catch {
          // ignore storage errors (modo privado, etc.)
        }
      }
    })
  }, [])

  return {
    name: platform?.platform_name || 'MYKLUBB',
    subtitle: platform?.login_subtitle || 'Control de tu club deportivo',
    logo: platform?.login_logo_url || '/assets/myklubb-logo-v-light.svg',
    bg: platform?.login_color_bg || '#0D0D0D',
    text: platform?.login_color_text || '#F2F2F3',
    accent: platform?.login_color_accent || '#B3F000',
  }
}
